import { trackEvent } from '../../../modules/analytics';

const BASE_ATTRIBUTES = { location: 'episode_editor' };

const events = {
  creationToolClicked: attributes => {
    trackEvent(
      'creation_tool_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      { providers: [mParticle] }
    );
  },
  fileUploaded: () => {
    trackEvent(
      'file_uploaded',
      {
        ...BASE_ATTRIBUTES,
        method: 'drag_and_drop',
        component: 'EpisodeEditorStagingArea',
      },
      { providers: [mParticle] }
    );
  },
  recordANewSegmentButtonClicked: () => {
    trackEvent(
      'record_a_new_segment_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  newRecordingButtonClicked: () => {
    trackEvent(
      'new_recording_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  mobileRecordingButtonClicked: () => {
    trackEvent(
      'mobile_recording_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  startRecordingButtonClicked: () => {
    trackEvent(
      'start_recording_button_clicked',
      { ...BASE_ATTRIBUTES },
      { providers: [mParticle] }
    );
  },
  stopRecordingButtonClicked: attributes => {
    trackEvent(
      'stop_recording_button_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      { providers: [mParticle] }
    );
  },
  recordingInputSelected: () => {
    trackEvent(
      'recording_input_selected',
      { ...BASE_ATTRIBUTES },
      {
        providers: [mParticle],
      }
    );
  },
  saveButtonClicked: () => {
    trackEvent(
      'save_button_clicked',
      { ...BASE_ATTRIBUTES },
      {
        providers: [mParticle],
      }
    );
  },
  previewButtonClicked: attributes => {
    trackEvent(
      'preview_button_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      {
        providers: [mParticle],
      }
    );
  },
  segmentDragAndDropped: attributes => {
    trackEvent(
      'segment_drag_and_dropped',
      { ...BASE_ATTRIBUTES, ...attributes },
      {
        providers: [mParticle],
      }
    );
  },
  createEpisodePageViewed: () => {
    trackEvent('InitiateCheckout', {}, { providers: [fbq] });
    trackEvent('ViewContent', {}, { providers: [rdt] });
  },
  recordEpisodePageViewed: () => {
    trackEvent('AddPaymentInfo', {}, { providers: [fbq] });
    trackEvent('AddToCart', {}, { providers: [rdt] });
  },
  episodeCreated: () => {
    trackEvent('episode_created', {}, { providers: [mParticle] });
  },
  segmentAdded: () => {
    trackEvent('segment_added', {}, { providers: [mParticle] });
  },
};

export default events;
